document.addEventListener("DOMContentLoaded", function () {
  $('.nav-link[class*="it-"]').each(function(){
    if( $(this).find('a').hasClass('is-active') ){
      $(this).addClass('is-active');
    } else {
      $(this).removeClass('is-active');
    }
  });

  $('.nav-link.menu-item--expanded>a').each(function(){
    $(this).after(`
        <span class="menu-item--expanded-plus-level0"></span>
    `);
  });
  $('.menu-level-1 .menu-item--expanded').each(function(){
    $(this).append(`
        <span class="menu-item--expanded-plus-level1"></span>
    `);
  });

  let conLevel0 = 0;
  $('.menu-level-0>.menu-item--expanded').each(function () {
    conLevel0++
    let id = 'level0-' + conLevel0;
    $(this).attr('id', id);
  });

  let conLevel1 = 0;
  $('.menu-level-1>.menu-item--expanded').each(function () {
    conLevel1++
    let id = 'level1-' + conLevel1;
    $(this).attr('id', id);
  });


  function hiddenLevel1(idShow){
    $('.menu-level-0>.menu-item--expanded').each(function () {
      if (
        $(this).find('.menu-level-1').css('display') == 'block' &&
        $(this).attr('id') !== idShow) {
          $(this).find('.menu-item--expanded-plus-level0').toggleClass('menu-item--expanded-plus-level0--open')
          $(this).find('.menu-level-1').toggle(500);
      }
    });
  }

  function hiddenLevel2(idShow){
    $('.menu-level-1>.menu-item--expanded').each(function () {
      if (
        $(this).find('.menu-level-2').css('display') == 'block' &&
        $(this).attr('id') !== idShow) {
          $(this).find('.menu-item--expanded-plus-level1').toggleClass('menu-item--expanded-plus-level1--open')
          $(this).find('.menu-level-2').toggle(500);
      }
    });
  }

  $('.menu-level-0>.menu-item--expanded').each(function () {
    $(this).click(function (e) {
      if (e.target.matches(".menu-item--expanded-plus-level0")) {
        hiddenLevel1($(this).attr('id'));
        $(this).find('.menu-item--expanded-plus-level0').toggleClass('menu-item--expanded-plus-level0--open')
        $(this).find('.menu-level-1').toggle(500);
        e.stopPropagation();
      }
    });
  });

  $('.menu-level-1>.menu-item--expanded').each(function () {
    $(this).click(function (e) {
      if (e.target.matches(".menu-item--expanded-plus-level1")) {
        hiddenLevel2($(this).attr('id'));
        $(this).find('.menu-item--expanded-plus-level1').toggleClass('menu-item--expanded-plus-level1--open')
        $(this).find('.menu-level-2').toggle(500);
        e.stopPropagation();
      }
    });
  });


});
